import { type FC } from "react";

import { isDefinedNumber } from "@/redux/modules/sample-admin.ts";

import { type Attribute, type RawAttributeDefault } from "../../../../graphql.js";
import ScriptInputField from "../../forms/ScriptInputField.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const AttributeDefaultCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const { value, context } = props;

  const defaults = value as RawAttributeDefault;

  // in case of template we use the scripting component for decoding the attributes and macros
  const defaultAttributeTemplate = defaults.template;
  if (defaultAttributeTemplate) {
    const attributes: Attribute[] = context.attributesForDecoration;

    return (
      <TableCell className={"cm-cell cm-display-mode"}>
        <ScriptInputField
          setSyntaxError={undefined}
          attributes={attributes ?? []}
          initialValue={defaultAttributeTemplate?.replace(/\n/g, " ") /*.replaceAll("{", "$")*/}
          disabled={true}
        />
      </TableCell>
    );
  }

  const defaultValue =
    (isDefinedNumber(defaults.defaultNumber) && String(defaults.defaultNumber)) ||
    defaults.defaultText ||
    defaults.defaultTerm?.name;
  return <div>{defaultValue}</div>;
};

export { AttributeDefaultCell };
export default AttributeDefaultCell;
